import {Component} from '@angular/core';
import {BankDetailsDirective} from '../bank-details.directive';
import {FormBuilder, FormControl, Validators} from '@angular/forms';
import {BankInteractor} from '../../../interactors/bank.interactor';
import {CommonUtil} from '../../../utils/common.util';

@Component({
  selector: 'app-bank-account-details-by-ifsc',
  templateUrl: './bank-account-details-by-ifsc.component.html',
  styleUrls: ['./bank-account-details-by-ifsc.component.css']
})
export class BankAccountDetailsByIfscComponent extends BankDetailsDirective {
  constructor(formBuilder: FormBuilder, protected bankInteractor: BankInteractor) {
    super();
    this.searchBankFormGroup = formBuilder.group({
      ifscCode: new FormControl(null, [Validators.pattern(/^[a-zA-Z0-9-\/ ]+$/), Validators.required]),
      bankName: new FormControl(null, Validators.required),
      bankCity: new FormControl(null, Validators.required),
      bankBranchName: new FormControl(null, Validators.required)
    });
  }

  async searchBankByIfsc(event: any): Promise<void> {
    if (!CommonUtil.isEmpty(event.target.value)) {
      const bankDetails = await this.bankInteractor.getBankDetailsByIfscCode(event.target.value);
      this.searchBankFormGroup.patchValue({
        ifscCode: bankDetails.ifsc,
        bankName: bankDetails.name,
        bankCity: bankDetails.city,
        bankBranchName: bankDetails.branch
      });
    }
  }

  public clearFieldsForIfsc(): void {
    this.searchBankFormGroup.controls.bankName.reset();
    this.searchBankFormGroup.controls.bankCity.reset();
    this.searchBankFormGroup.controls.bankBranchName.reset();
  }
}

